// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"33b48a43","450":"321cb835","641":"0388d602","793":"93c0bebc"}[chunkId] + ".css";
};